import { useState, memo } from "react";
import Header from "../../../components/header";
import RightSidebar from "../../../components/right-sidebar";
import PageTransition from "../../../components/page-transition";
import StudentProfileReminder from "../../../components/student-profile-reminder";

const RightSection = memo(({ children }) => {
    const [rightSidebarOpen, setRightSidebarOpen] = useState(false);

    return (
        <div>
            <div>
                <Header onRightSidebarToggle={() => setRightSidebarOpen(prev => !prev)} />
            </div>
            <StudentProfileReminder />
                <div className='content' style={{ marginTop: "60px" }}>
                    <PageTransition>
                        {children}
                    </PageTransition>
                </div>
            <RightSidebar isOpen={rightSidebarOpen} onClose={() => setRightSidebarOpen(false)} />
        </div>
    );
});
export default RightSection;
